module.exports = __webpack_public_path__ + "static/media/trash_icon.2b1c2e53.svg";